module.exports = __webpack_public_path__ + "rubric-fab-backgroundwp95c2ba4adadf457fc5cc5a92f7c6d958.png";